<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03_tit"></a><a id="page_iii"></a><strong>THE MIDDLEMAN AND OTHER STORIES</strong></h1>
<p class="author"><strong>BHARATI MUKHERJEE</strong></p>
<p class="publisher"><img alt="images" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_tit.vue?a21b131a